import { motion } from 'framer-motion';
import { FaArrowLeft, FaBuilding, FaUserClock } from 'react-icons/fa';
import ReactDOM from 'react-dom';

interface SolutionsMobileMenuProps {
  isOpen: boolean;
  onBack: () => void;
}

const SolutionsMobileMenu: React.FC<SolutionsMobileMenuProps> = ({ isOpen, onBack }) => {
  const menuContent = (
    <motion.div
      initial={{ x: '100%' }}
      animate={{ x: isOpen ? '0%' : '100%' }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30,
        duration: 0.2,
        ease: 'easeOut',
      }}
      className="fixed inset-0 w-full h-full bg-[#1E2A3A] z-[1100] isolate"
      style={{ pointerEvents: isOpen ? 'auto' : 'none' }}
    >
      <button
        onClick={onBack}
        className="absolute top-4 left-4 text-[#0084ff] text-xl"
        aria-label="Back"
      >
        <FaArrowLeft />
      </button>

      <div className="text-white text-2xl font-bold p-4 pl-12">Solutions</div>

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.2 }}
        className="flex flex-col items-start p-8 text-white gap-6"
      >
        <div className="flex flex-col gap-2">
          <h3 className="text-[#e2ba57] font-bold flex items-center gap-2"><FaBuilding /> For Business</h3>
          <a href="/solutions/corporate-audit-shield" className="pl-6 text-lg">Corporate Compliance</a>
          <p className="pl-6 text-sm text-gray-400">Audit-proof your remote onboarding.</p>
        </div>

        <div className="w-full border-b border-gray-700 my-2"></div>

        <div className="flex flex-col gap-2">
          <h3 className="text-[#e2ba57] font-bold flex items-center gap-2"><FaUserClock /> For Individuals</h3>
          <a href="/solutions/urgent-i9" className="pl-6 text-lg">Urgent I-9 Verification</a>
          <p className="pl-6 text-sm text-gray-400">Same-day appointments available.</p>
        </div>
      </motion.div>
    </motion.div>
  );

  return isOpen
    ? ReactDOM.createPortal(menuContent, document.body)
    : null;
};

export default SolutionsMobileMenu;